import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'evaluate-question-new',
  created () {
    this.$store.dispatch('USERTYPE_ALL_GET', {})
    this.getNormalQuestions()
    this.getPersonnelQuestions()
    this.getBusinessQuestions()
  },
  data () {
    return {
      title: '',
      selectedUserType: null,
      normalQuestions: [],
      selectedNormalQuestion: null,
      personnelQuestions: [],
      selectedPersonnelQuestion: null,
      businessQuestions: [],
      selectedBusinessQuestion: null,
      isOwnNormalQuestion: false,
      isOwnPersonnelQuestion: false,
      isOwnBusinessQuestion: false,
      evaluateNormalShopMaster: 1,
      evaluateNormalAnswerUserTypeAllCheck: false,
      evaluateNormalAnswerUserTypeIds: [],
      evaluatePersonnelShopMaster: 1,
      evaluatePersonnelAnswerUserTypeAllCheck: false,
      evaluatePersonnelAnswerUserTypeIds: [],
      evaluateBusinessShopMaster: 1,
      evaluateBusinessAnswerUserTypeAllCheck: false,
      evaluateBusinessAnswerUserTypeIds: [],
      notificationStartDate: '',
      answerStartDate: '',
      endDate: '',
      endDateRange: this.answerStartDateFormat < this.endDateFormat,
      joinRestrictionDate: '',
      shopRestrictionDate: '',
      canValidate: true,
      savingFlag: false
    }
  },
  computed: {
    joinRestrictionDateFormat () {
      return DayJs(this.joinRestrictionDate).format('YYYY-MM-DD')
    },
    shopRestrictionDateFormat () {
      return DayJs(this.shopRestrictionDate).format('YYYY-MM-DD')
    },
    notificationStartDateFormat () {
      return DayJs(this.notificationStartDate).format('YYYY-MM-DD')
    },
    answerStartDateFormat () {
      return DayJs(this.answerStartDate).format('YYYY-MM-DD')
    },
    endDateFormat () {
      return DayJs(this.endDate).format('YYYY-MM-DD')
    },
    validation: function () {
      const today = DayJs(new Date()).format('YYYY-MM-DD')
      var v = {
        title: !!this.title,
        selectedUserType: !!this.selectedUserType,
        notificationStartDate: !!this.notificationStartDate,
        notificationStartDateRange: DayJs(today).isBefore(this.notificationStartDateFormat),
        answerStartDate: !!this.answerStartDate,
        answerStartDateRange: this.notificationStartDateFormat < this.answerStartDateFormat,
        endDate: !!this.endDate,
        endDateRange: this.answerStartDateFormat < this.endDateFormat,
        joinRestrictionDate: !!this.joinRestrictionDate,
        shopRestrictionDate: !!this.shopRestrictionDate,
        evaluateNormalAnswerUserTypeIds: this.evaluateNormalAnswerUserTypeIds.length > 0,
        evaluatePersonnelAnswerUserTypeIds: this.evaluatePersonnelAnswerUserTypeIds.length > 0,
        evaluateBusinessAnswerUserTypeIds: this.evaluateBusinessAnswerUserTypeIds.length > 0,
        notInput: !!this.title && !!this.selectedUserType && !!this.joinRestrictionDate &&
        !!this.shopRestrictionDate &&
        !!this.notificationStartDate &&
        DayJs(today).isBefore(this.notificationStartDateFormat) &&
        !!this.answerStartDate &&
        this.notificationStartDateFormat < this.answerStartDateFormat &&
        !!this.endDate &&
        this.answerStartDateFormat < this.endDateFormat
      }
      if (this.evaluateNormalShopMaster === 2) {
        v.notInput = this.evaluateNormalAnswerUserTypeIds.length > 0
      }
      if (this.evaluatePersonnelShopMaster === 2) {
        v.notInput = this.evaluatePersonnelAnswerUserTypeIds.length > 0
      }
      if (this.evaluateBusinessShopMaster === 2) {
        v.notInput = this.evaluateBusinessAnswerUserTypeIds.length > 0
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    userTypes () {
      return this.$store.getters.usertypesAll
    },
    userTypesFiltered () {
      return this.$store.getters.usertypesAll.filter(userType => userType.id !== this.selectedUserType)
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getNormalQuestions () {
      let data = {}
      await this.$store.dispatch('GET_NORMAL_QUESTION_ALL', { data })
      .then(res => {
        this.normalQuestions = res.questions
      })
      .catch(err => {
        console.log(err)
        return
      })
    },
    async getPersonnelQuestions () {
      let data = {}
      await this.$store.dispatch('GET_PERSONNEL_QUESTION_ALL', { data })
      .then(res => {
        this.personnelQuestions = res.questions
      })
      .catch(err => {
        console.log(err)
        return
      })
    },
    async getBusinessQuestions () {
      let data = {}
      await this.$store.dispatch('GET_BUSINESS_QUESTION_ALL', { data })
      .then(res => {
        this.businessQuestions = res.questions
      })
      .catch(err => {
        console.log(err)
        return
      })
    },
    onChangeNotificationStartDate: function () {
      if (this.notificationStartDate) {
        this.joinRestrictionDate = DayJs(this.notificationStartDateFormat).subtract(2, 'month')
        this.shopRestrictionDate = DayJs(this.notificationStartDateFormat).subtract(1, 'month')
      } else {
        this.joinRestrictionDate = ''
        this.shopRestrictionDate = ''
      }
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      this.savingFlag = true
      this.$store.dispatch('EVALUATE_QUESTION_CREATE', {
        data: {
          title: this.title,
          target_user_type_id: this.selectedUserType,
          evaluate_normal_question_id: this.selectedNormalQuestion,
          evaluate_personal_question_id: this.selectedPersonnelQuestion,
          evaluate_business_question_id: this.selectedBusinessQuestion,
          is_own_normal_question: this.isOwnNormalQuestion,
          is_own_personal_question: this.isOwnPersonnelQuestion,
          is_own_business_question: this.isOwnBusinessQuestion,
          notification_start_date: this.notificationStartDateFormat,
          answer_start_date: this.answerStartDateFormat,
          answer_end_date: this.endDateFormat,
          join_restriction_date: this.joinRestrictionDateFormat,
          shop_restriction_date: this.shopRestrictionDateFormat,
          evaluate_normal_shop_master: this.evaluateNormalShopMaster,
          evaluate_normal_answer_user_type_ids: this.evaluateNormalAnswerUserTypeIds,
          evaluate_personal_shop_master: this.evaluatePersonnelShopMaster,
          evaluate_personal_answer_user_type_ids: this.evaluatePersonnelAnswerUserTypeIds,
          evaluate_business_shop_master: this.evaluateBusinessShopMaster,
          evaluate_business_answer_user_type_ids: this.evaluateBusinessAnswerUserTypeIds
        }
      })
      .then(res => {
        this.$router.push({path: '/evaluate_question'})
      })
      .catch(err => console.log(err))
    },
    onClickCancel: function () {
      this.$router.push('/evaluate_question_list')
    },
    evaluateNormalAnswerUserTypeAllChecked: function () {
      this.evaluateNormalAnswerUserTypeIds = this.evaluateNormalAnswerUserTypeAllCheck ? [...this.userTypes.map((userType) => userType.id)] : []
    },
    evaluatePersonnelAnswerUserTypeAllChecked: function () {
      this.evaluatePersonnelAnswerUserTypeIds = this.evaluatePersonnelAnswerUserTypeAllCheck ? [...this.userTypes.map((userType) => userType.id)] : []
    },
    evaluateBusinessAnswerUserTypeAllChecked: function () {
      this.evaluateBusinessAnswerUserTypeIds = this.evaluateBusinessAnswerUserTypeAllCheck ? [...this.userTypes.map((userType) => userType.id)] : []
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/evaluate-question-new.js